interface ExplicitContentBadgeProps {
  label?: string;
  className?: string;
}

export default function ExplicitContentBadge({
  label = 'Explicit',
  className = '',
}: ExplicitContentBadgeProps) {
  return (
    <span
      aria-label="Explicit content"
      className={`inline-flex items-center rounded border border-red-500 bg-red-50 px-2 py-0.5 text-[11px] font-bold uppercase leading-none tracking-wide text-red-700 dark:border-red-400 dark:bg-red-950/40 dark:text-red-200 ${className}`}
    >
      {label}
    </span>
  );
}
